import { SmartenitPlugin } from '../smartenit-plugin';
import { IWebSocketDeviceMessage } from '../../websockets/websocket-device-message.interface';

export class SystemServerPlugin extends SmartenitPlugin {
  // Methods

  public update(channel: string = '') {
    // /comps/0/procs/SystemServer/methods/Upgrade
    this.executeMethod(
      this.componentId,
      this.processorName,
      'Upgrade',
      {
        Channel: channel
      },
      false
    );
  }

  public getWiFiNetwork(essid: string, intface: string, password: string) {
    this.executeMethod(
      this.componentId,
      this.processorName,
      'ConnectWifi',
      {
        ESSID: essid,
        Interface: intface,
        Password: password,
      },
      false
    );
  }

  public ping() {
    this.executeMethod(
      this.componentId,
      this.processorName,
      'Ping',
      {},
      false
    );
  }

  public getScanWifi() {
    this.executeMethod(
      this.componentId,
      this.processorName,
      'ScanWifi',
      {},
      false
    );
  }

  // General

  public getStatusPayload(): any {
    return [];
  }

  public getStatus(): void { }

  public processMessage(message: IWebSocketDeviceMessage, timestamp?: number): any {
    const response = message && message.data && message.data.response;
    const attribute = message && message.attributeOrMethod;
    if (attribute === 'PingResponse') {
      this._onUpdate.next({ pingResponse: response.value });
    } else if (attribute === 'UpgradeResponse') {
      this._onUpdate.next({ upgradeResponse: response.value });
    } else if (attribute === 'ScanWifiResponse') {
      this._onUpdate.next({ scanWifiResponse: response.value });
    } else if (attribute === 'ConnectWifiResponse') {
      this._onUpdate.next({ connectWifiResponse: response.value });
    }
  }
}
